export default __webpack_public_path__ + "static/media/icon_talk_regular.99405e36.svg";